export default __webpack_public_path__ + "static/media/Ballroll_00220.a0877de4.png";